import Button from "../../../components/button/Button";
import EmailEditor from "../../quill/EmailEditor";
import TemplateSelectModal from "../../TemplateSelectModal";
import { useEffect, useState } from "react";
import { FormControl, FormGroup, FormLabel } from "react-bootstrap";

const SendEmailForm = ({
  selectedTemplate,
  emailTemplates,
  templateError,
  emailTemplateBody,
  contact,
  handleSelectedTemplate,
  handleSendEmail,
  handleCloseEmailModal,
}) => {
  const [emailContent, setEmailContent] = useState("");
  const [subjectContent, setSubjectContent] = useState("");
  const [image, setImage] = useState(null);

  const reformatEmailText = (string) => {
    const splitedString = string?.split("\r\n");
    const newString = splitedString?.map((string) => `<p>${string}<br></p>`);
    return newString?.join("");
  };

  const emailContentHandler = (content) => {
    setEmailContent(content);
  };

  useEffect(() => {
    if (selectedTemplate?.body != null) {
      setSubjectContent(selectedTemplate?.subject ?? "");
    } else {
      setSubjectContent(emailTemplateBody?.subject);
    }
  }, [emailTemplateBody, selectedTemplate?.body, selectedTemplate?.subject]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.size <= 5485760) {
      setImage(file);
    } else {
      alert("File size exceeds 5MB limit");
    }
  };
  const handleTemplateSelect = (template) => {
    handleSelectedTemplate(template, contact);
  };

  return (
    <div>
      <div className="mt-3">
        <label htmlFor="subject" className="form-label">
          Subject
        </label>
        <input
          type="text"
          id="subject"
          className="form-control py-2"
          value={subjectContent || ""}
          readOnly
        />
        <div className="text-muted mt-1" style={{ fontSize: 13 }}>
          Edit the subject on the Email Templates page.
        </div>
      </div>
      <div className="mt-5">
        <EmailEditor
          emailBody={reformatEmailText(selectedTemplate?.body ?? emailTemplateBody?.text ?? "")}
          handleEmailContent={emailContentHandler}
        />
      </div>
      <div className="mt-3">
        <span className="text-muted">Template: </span>
        <span>{selectedTemplate?.name || "None"}</span>
        {" — "}
        <TemplateSelectModal
          templates={emailTemplates || []}
          onSelect={handleTemplateSelect}
        />
        <div className="text-start text-danger text-10">
          {templateError ? templateError : ""}
        </div>
      </div>
      <div className="d-flex justify-content-between mt-4">
        <FormGroup className="me-5 col-5">
          <FormLabel>Attach Image (up to 5MB)</FormLabel>
          <FormControl type="file" onChange={handleFileChange} />
        </FormGroup>
        {/*<Button customClassName="btn btn-outline-secondary-intel btn-small py-2 mt-3 px-3 ">*/}
        {/*  <AttachmentIcon*/}
        {/*    fill="currentColor"*/}
        {/*    className="me-2"*/}
        {/*    width="12"*/}
        {/*    height="18"*/}
        {/*  />*/}
        {/*  Attach Files*/}
        {/*</Button>*/}
        <Button
          onClick={() =>
            handleSendEmail(
              contact,
              selectedTemplate,
              subjectContent,
              emailContent,
              handleCloseEmailModal,
              image
            )
          }
          customClassName="btn btn-primary btn-small py-2 mt-3 px-3 text-white"
        >
          Send Email
        </Button>
      </div>
    </div>
  );
};

export default SendEmailForm;
